import React, { PureComponent } from 'react'
import styled from 'styled-components'
import AdminCard from '../admin'
import { categoriesArray } from '../../func/skills.js'

const Wrapper = styled.div`
  width: 90%;
  position: relative;
  border-radius: 20px;
  transition: background-color 0.5s ease;
  margin-left: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? '5%' : '50px'};
  &:hover {
    background-color: rgb(243, 243, 243);
  }
`

const Content = styled.div`
  padding: 15px;
`

const Header = styled.div`
  display: flex;
  margin: 5px 0;

  ${props =>
    props.mediaQuery === 'smartphone' &&
    `
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `};
`

const Body = styled.div`
  margin: 10px 0 10px 10px;
`

const HeaderInfo = styled.div`
  max-width: 70%;
  padding: 5px 0;
`

const ProfilePicture = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 10px;
  background-color: rgb(233, 233, 233);
  margin: 0 10px;
  object-fit: cover;
  background: url('/assets/svg/user.svg');
  background-size: cover;
`

const ModifyIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/modif.svg');
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 99;
`

const IconWrapper = styled.div`
  height: 70px;
  width: 170px;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 999999;
  display: flex;
  justify-content: space-around;
`

const ValidIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/valid.svg');
`

const CloseIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/close.svg');
`
const RemoveIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/remove.svg');
`

const Name = styled.div`
  font-size: 17px;
  color: rgb(61, 60, 60);
  font-weight: bold;
`

const Member = styled.div`
  font-size: 14px;
  color: rgb(108, 108, 108);
  margin-bottom: 15px;
`

const Text = styled.div`
  font-size: 13px;
  color: rgb(108, 108, 108);
  margin: 5px 0;
`

const Link = styled.a`
  font-size: 13px;
  color: rgb(108, 108, 108);
  text-decoration: underline;

  &:visited {
    color: rgb(108, 108, 108);
  }
`

const Skills = styled.div`
  max-width: 100%;
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`

const Skill = styled.div`
  padding: 5px 10px;
  font-weight: bold;
  font-size: 13px;
  margin: 5px 5px 0 0;
  background-color: rgb(233, 233, 233);
  border-radius: 7px;
  color: rgb(79, 79, 79);
  cursor: default;
`

class Card extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isModif: false
    }
  }

  toggleAdminCard = () => {
    this.setState({ isModif: !this.state.isModif })
  }

  render() {
    let {
      firstname,
      lastname,
      member,
      company,
      job,
      adress,
      cp,
      phone1,
      phone2,
      mobilephone,
      email,
      website1,
      website2,
      twitter,
      skills,
      id,
      profilpic
    } = this.props.item
    return (
      <Wrapper mediaQuery={this.props.mediaQuery}>
        {!this.state.isModif && this.props.admin ? (
          <ModifyIcon onClick={() => this.toggleAdminCard()} />
        ) : (
          ''
        )}
        {this.state.isModif && this.props.admin ? (
          <AdminCard
            item={this.props.item}
            toggleAdminCard={() => this.toggleAdminCard()}
            deleteMember={() => this.props.deleteMember(id)}
            validButton={member => this.props.modifyMember(id, member)}
            newCat={categoriesArray()}
          />
        ) : (
          <Content>
            <Header mediaQuery={this.props.mediaQuery}>
              <ProfilePicture id={id} src={profilpic} alt="profile_pic" />
              <HeaderInfo>
                <Name>{lastname + ' ' + firstname}</Name>
                <Text>{job}</Text>
                <Text>{company}</Text>
              </HeaderInfo>
            </Header>
            <Body>
              <Text>{adress}</Text>
              <Text>{cp}</Text>
              <Text>{phone1}</Text>
              <Text>{mobilephone}</Text>
              <Text>
                <Link href={'mailto:' + email}>{email}</Link>
              </Text>
              <Text>
                <Link href={'http://twitter.com/' + twitter} target="_blank">
                  {twitter ? '@' + twitter : ''}
                </Link>
              </Text>
              <Text>
                <Link href={'http://' + website1} target="_blank">
                  {website1}
                </Link>
              </Text>
              <Text>
                <Link href={'http://' + website2} target="_blank">
                  {website2}
                </Link>
              </Text>
            </Body>
          </Content>
        )}
      </Wrapper>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/card/index.js